import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

// NOTE: No images were provided for this writeup.
// If you add them later, import them here and add <ImageComponent /> blocks inside sections.
// Example:
import cover from "../../../../src/assets/blade-runner/session12/blade-runner-session-12-cover.webp";
import message from "../../../../src/assets/blade-runner/session12/wallace-tower-quell-message-success.webp";
import instantFix from "../../../../src/assets/blade-runner/session12/instant-fix.webp";
import twoQuells from "../../../../src/assets/blade-runner/session12/two-quells.webp";
import facingNiander from "../../../../src/assets/blade-runner/session12/facing-niander.webp";
import longShot from "../../../../src/assets/blade-runner/session12/marion-long-shot.webp";
import niander from "../../../../src/assets/blade-runner/session12/real-niander.webp";
import epilogue from "../../../../src/assets/blade-runner/session12/epilogue.webp";
import bladeRunners from "../../../../src/assets/blade-runner/session12/blade-runners.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};

const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSessionDoubleQuell = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});

  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => setShowModal("show");
  const handleCloseModal = () => setShowModal("", "");

  const section1Data = [
    {
      title: "Tower Approach",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={cover}
            caption="Prophecy"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="At the top of Wallace Tower we find the questions to the answers and the dramatic finale of the Fiery Angels case file plays out."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={message}
            caption="Message"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="An encrypted addendum to an Esper search for Wallace Corp Tower blueprints."
          ></ImageComponent>
          {/* Optional image if added later */}
          {/* <ImageComponent
            image={cover}
            caption="Wallace Corp Tower"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Skinner arrives in a maintenance vehicle. Marion follows in a spinner. Wallace Tower watches them both."
          ></ImageComponent> */}

          <p>
            Skinner approaches <strong>Wallace Corp Tower</strong> in a low-key
            maintenance vehicle, one range category ahead of Marion—who trails
            behind in his <strong>LAPD spinner</strong>.
          </p>

          <p>
            Skinner gets a pass from the automated security AI—clean, quiet, and
            impersonal. Marion pings the <strong>Esper</strong> for data and
            gets the corporate brick wall:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Unable to provide floor plans for Wallace Corp Tower due to
              privileged protection status.”
            </font>
          </p>

          <p>
            But there’s more: a flashing red bar—an encrypted addendum. Marion
            decodes it and sees a passcode and directions to{" "}
            <strong>Quell’s</strong> office. He’s challenged by aerial security,
            gives the passcode, and is allowed in.
          </p>

          <p>
            The detectives meet up in the garage and enter the tower, moving
            through the halls like it’s business as usual.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Quell’s Office",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={twoQuells}
            caption="Two Quells"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody=""
          ></ImageComponent>
          <p>
            The executive corridor outside Quell’s office is quiet except for
            the blade runners' footsteps ticking on faux marble. The air smells
            like <strong>filtered rain</strong> and expensive disinfectant. The
            door sighs open as they approach—motion detection, polite and
            non-optional.
          </p>

          <p>
            Quell’s office is a shrine to controlled power: a huge slab desk
            made of black glass and an ultra-res pix-oil cityscape of neon and
            rain projected tastefully on the wall.
          </p>

          <p>
            Quell sits perfectly composed—sharp white business suit, hands
            folded, posture pristine. Two Wallace security guards flank her,
            armored and rigid, rifles held low but not relaxed.
          </p>

          <p>
            Quell lifts her eyes to the detectives, unsurprised, and speaks
            without warmth, like she’s reading a statement already approved:
          </p>

          <p>
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “There is a security breach as mentioned in the message you
              received. Communications outside are blocked; that’s not our
              doing. Bootleg replicants have infiltrated the building. They’re
              wearing the faces of key personnel. My security detail has been
              compromised. These two and you are all I can trust.”
            </font>
          </p>

          <p>
            Behind the desk—an unmarked back door you didn’t notice a second ago
            slides open with a soft, precise click.
          </p>

          <p>
            Another woman steps into the room.
            <strong> It’s Quell.</strong>
          </p>

          <p>
            Same face. Same eyes. Same voice caught in the throat before words.
            But dressed in black, moving like someone who just walked through a
            nightmare and refuses to show it.
          </p>

          <p>
            The white-suited Quell stands at the same instant the black-suited
            Quell stops. Security shifts—unsure where to aim.
          </p>

          <p>
            Both Quells draw their guns at once—identical motion, identical
            angles. And they speak over each other:
          </p>

          <p>
            <font style={{ fontStyle: "italic", color: "#C21E56" }}>
              “Kill her.”
            </font>{" "}
            <font style={{ fontStyle: "italic", color: "#C21E56" }}>
              “No! Kill her.”
            </font>
          </p>

          <p>
            The guards bark, voices sharp with panic disguised as protocol:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Drop your weapons! Now!”
            </font>
          </p>

          <p>
            Their rifles come up—not at the Quells—at{" "}
            <strong>Skinner and Marion</strong>.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    // ✅ INSERTED SECTION: Gunfight comes right after Quell’s Office
    {
      title: "Gunfight & Kill Switch",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={instantFix}
            caption="Instant Fix"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Skinner takes an Instant Fix as Wallace guard stalks him with a PKD shotgun."
          ></ImageComponent>

          <p>A gunfight erupts inside the office.</p>

          <p>
            At first Skinner aims at the injured Quell who came in through the
            secret panel. He says,
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “allow me, we can’t have these renegades taking over”
            </font>{" "}
            then pivots and shoots at Quell in the white suit behind the desk.
          </p>

          <p>
            Skinner tries to take cover behind furniture as one of the Wallace
            guards mercilessly stalks him with a <strong>PKD shotgun</strong>,
            blasting away pieces of corporate luxury—and Skinner’s hiding place—
            while Skinner swallows an <strong>Instant Fix</strong> and returns
            fire.
          </p>

          <p>
            The injured Quell and the white-suited Quell exchange gunfire while
            the second Wallace guard and Marion trade bullet for bullet.
          </p>

          <p>
            The Quell in the white suit goes down and the other Quell slides
            beside Marion:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Look, it’s me. I’m going to try and get to the rep Quell’s body
              and hit the kill switch on these fucking replicants. Cover me.”
            </font>
          </p>

          <p>
            Quell dashes and leaps across the desk as the guard blasts her. She
            has an impaled hand and a broken leg, and Skinner muttering:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “fuck, they’re gonna kill us”
            </font>
          </p>

          <p>
            Then Quell slaps a <strong>triangle stitched patch</strong> onto the
            front of the dead Quell’s white suit.
          </p>

          <p>
            The Wallace guards pause… shimmer… and turn to ash. The same
            spontaneous kill-switch combustion Marion and Skinner saw back at
            the Memory Lab.
          </p>

          <p>
            Marion hauls Skinner upright with FIRST AID. Quell limps, eyes the
            ash pile, and deadpans:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “That’s a pity. I could have used that shotgun.”
            </font>
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Debrief: The Honey Pot & MedLab",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <p>
            Quell demands to know how the detectives knew how to find her and
            how they got through security. Marion shows her the encrypted
            addendum—the passcode, the directions, the invitation.
          </p>

          <p>
            Quell’s laugh is mirthless:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “That’s bullshit. The replicant Quell sent that; all that gushing
              in the message about you saving me? She was laying a honey pot
              trap; I’d never gush over you. But, considering the help you’re
              here to lend, I am going to thank you.”
            </font>
          </p>

          <p>
            Skinner presses her:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Now is the time to tell us the truth.”
            </font>
          </p>

          <p>
            Quell insists Wallace security has been compromised, systems
            hijacked, ambushes staged—then snaps:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “I thought you were the detectives and would have something for
              me!”
            </font>
          </p>

          <p>
            She offers Skinner a happy pill (too late) and hands Marion a Soviet
            happy pill. Marion pockets it and takes a pull from his hip flask
            instead.
          </p>

          <p>
            Quell barks they have to reach Niander's executive suite, but that
            there’s time for one stop. She leads them to a med lab with a
            single-person immersion bubble—clean, clinical, designed to fix
            bodies like problems.
          </p>

          <p>
            It heals damage fast. It stacks with street meds. Marion watches
            Quell go in and out again, newly steady—still wondering who died in
            the office… and who didn’t.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Top Floor: The Gold Cathedral",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={facingNiander}
            caption="Facing Niander"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Niander Wallace preaches his vision of a world where chains can finally be broken."
          ></ImageComponent>

          <p>
            In the elevator ascent Quell checks her gun:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Make sure you’re ready. If they got to Niander we’re going to
              have to take him and anyone around him out.”
            </font>
          </p>

          <p>
            Doors open into a palatial suite—columns, gold, and a view that
            feels like the city is a possession. An owl sits on a golden perch.
            A woman smokes in shadow. And Niander Wallace speaks like scripture.
          </p>
          <p>
            Niander:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “They cried to the Lord in their trouble, and he saved them from
              their distress. He brought them out of darkness, the utter
              darkness, and broke away their chains.”
            </font>
            <p></p>
            Niander Wallace stands in the center of the hall, bathed in gold
            like the sun decided to stop and stare. His sightless eyes turn
            toward Marion, Skinner, and Quell with unsettling precision, as if
            your footsteps have signatures.
            <p>
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                “Welcome, Blade Runners, to my inner sanctum. There is no cause
                for alarm. I am… sincerely happy to meet you.”
              </font>
            </p>
            <p>
              Quell mutters to Skinner and Marion,{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                “that is not Niander, it’s a fucking skinjob”
              </font>
              , her face wild and mottled, unlike the calm collected poker face
              of the Quell they have known all along.
            </p>
            Niander takes a slow breath, savoring the taste and sound of his own
            words.{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You wear a badge. You wear a burden. You walk among the chained
              and call it order. But listen—there is an old truth, older than
              these towers and their glass. That which is within you, if drawn
              forth, will set you free… and that which is within you, if not
              drawn forth, will destroy you.”
            </font>{" "}
            A faint smile.{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Los Angeles is full of people who have never drawn themselves
              forth. They rot quietly. They obey beautifully. They die without
              ever being born.”
            </font>{" "}
            He spreads his hands, a priest offering an psalm.{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Am I the true Niander Wallace, you wonder, or a copy of the
              original? Does it really matter, if no one can tell the
              difference? If chains can finally be broken? The Niander Wallace
              you know has helped millions of people… and he has enslaved
              millions, too.”
            </font>{" "}
            His voice softens, almost tender.{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You are standing at the threshold of a world that can change
              forever. You simply need to let us go—…or join us.”
            </font>
          </p>
          <p>
            Quell’s face goes wild:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “That is not Niander, it’s a fucking skinjob.”
            </font>
          </p>

          <p>
            Marion says it out loud, because somebody has to:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “I don’t know who to believe.”
            </font>{" "}
            He grapples Quell—guns clatter and skitter across the floor. The
            woman by the owl steps into the light. It's
            <strong> Lilith Tyrell.</strong>
          </p>

          <p>
            She holds Quell’s gun in one hand—and a translucent memory sphere in
            the other.
          </p>

          <p>
            Skinner’s anger turns prophetic:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “What is it with you replicants and your god complex? The power
              comes from the city!”
            </font>
          </p>

          <p>
            He shoots “Niander” who stumbles back against a gold pillar, his
            hand bleeding and broken from the gun blasting through his hand.
            <br />
            Skinner:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Hold out your other hand Niander, then you’ll have the full
              stigmata and be a real savior.”
            </font>
          </p>

          <p>
            A troop transport hums onto the balcony and drops a metal ramp. Two
            Wallace guards in full-body armor spill into cover.
          </p>

          <p>
            Quell glares at Marion who lets her go realizing she's on their
            side. He hands her his spare Ender Assault Rifle and she says{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              "Good. We can be friends again."
            </font>{" "}
            Then, she turns and shoots “Niander.” Marion shoots “Niander” as
            well and scores a critical hit. The false prophet drops—fractured
            skull, dead.
          </p>

          <p>
            Skinner pats the fake Niander's corpse for a kill switch—then
            understands:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “This Niander was a puppet… it’s Lilith running things.”
            </font>
          </p>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={longShot}
            caption="Long Shot"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion takes a long shot at Lilith."
          ></ImageComponent>
          <p>
            Lilith runs for the transport under cover fire. Quell drops again,
            Dead. Skinner shouts,{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              "We have to stop Lilith Marion, now!"
            </font>
          </p>

          <p>
            Marion can’t catch her on foot. He thumbs his PKD to{" "}
            <strong>.222</strong> for the long shot. He takes a breath, sights,
            and fires.
          </p>

          <p>Critical hit—through the heart.</p>

          <p>
            Lilith turns, eyes wild and disbelieving. The owl launches into the
            night sky as she topples off the ramp—six hundred stories down,
            heart’s blood trailing into the rain. And she falls and fades into
            the dark corners and garish glare of Los Angeles.
          </p>

          <p>
            The transport retreats. The replicant Niander shimmers… then turns
            to dust.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "The Real Niander",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={niander}
            caption="Niander"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="How you have fallen from heaven, morning star, daughter of the dawn."
          ></ImageComponent>

          <p>
            Quiet footsteps. Niander Wallace enters with bodyguards in perfect
            formation. He walks to the balcony edge and intones ruefully:
            <br />
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “How you have fallen from heaven, morning star, daughter of the
              dawn.”
            </font>
          </p>

          <p>
            He doesn’t shout. He doesn’t need to. The entire room listens.
            <br />
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You have fought the good fight, you have finished the race, you
              have kept the faith. Now there is in store for you the crown of
              righteousness.”
            </font>
            A pause—then, softly:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Wallace Corporation does not forget those who protect the
              future.”
            </font>
          </p>
          <p>
            Skinner demands answers:
            <br />
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “how did you you let this happen? With all your eyes how could you
              not see this coming?”
            </font>
          </p>
          <p>
            Niander ponders: <br />
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “I see everything, but not always in time, and of course, every
              failure is just a precursor to success. Order is always restored.
              Excuse me detectives.”
            </font>
          </p>
          <p>
            Niander cuts the audience short as is his wont. He walks away and
            Marion, one of his children, shouts{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>“STOP”</font>{" "}
            . <br />
            With a success on MANIPULATION roll, Niander halts but keeps his
            back toward the dectectives.
            <p>
              Marion tells Niander,{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                “we want a liaison with Wallace Corporation. A dedicated liaison
                we can work closely with.”
              </font>
            </p>
            <p>
              Niander nods,{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                “Tomorrow at LAPD HQ, 10am. You’ll have a new representative.
                That should give you some time to sleep in and rest from all
                this . . . unpleasantness.”
              </font>
            </p>
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Epilogue",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={epilogue}
            caption="Epilogue"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody=""
          ></ImageComponent>

          <p>
            Next morning Skinner and Marion wait, convinced Wallace stiffed them
            until the door opens.
          </p>

          <p>
            Quell walks in—not dead, perfectly recovered. Healed. New.
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Did you miss me?”
            </font>
          </p>

          <p>
            As for the others in our story, we park the game for awhile awaiting
            Case File 03 publication; so, let’s just catch up with them as the
            credits roll:
            <br />
            <br />
            <p>
              <b>Lilith Tyrell</b>
              <br />
              Manpower is dedicated to finding her body, or ashen traces . . .
              on the ground, or any of the balconies or ductwork along the
              mile-long fall from the top of the tower. No trace of the
              traitorous Lilith is found. Where is the memory sphere? Did the
              troop transport travel to Arcadia as replicant Niander hinted? And
              where is the owl, Tyrell’s precious owl, in the sky over LA?{" "}
            </p>
            <p>
              <b>Quell</b>
              <br /> Over the days to come, Marian and Skinner realize Quell is
              and was a replicant all along, her hateful rhetoric toward the
              betraying replicants a reflection of her own issues about her
              origin. The newest Quell was memory refreshed the morning of the
              tower takeover. The latest liaison to the RepDetect Unit at LAPD
              does not in fact recall the events of the day . . . the new Quell
              does not “remember” the fire fight, the death of her doppleganger
              and shooting an imposter Niander. Sometimes, ignorance, or being
              born yesterday is a blessing.
            </p>
            <p>
              <b>Niander Wallace</b>
              <br /> In the executive suite, Niander sits alone in the gold
              light, listening to the city like it’s a choir. He does not rage.
              He does not grieve. He simply begins planning what comes
              next—because to him, this was not an attack. It was feedback.
              Experiments must be adjusted. Strategies must be updated. And, as
              always, humanity must be saved from itself.{" "}
            </p>
            <p>
              <b>Coco</b>
              <br /> Somewhere under LAPD fluorescence, Coco scrubs his hands
              longer than he needs to. He doesn’t know if he did the right
              thing, but he followed protocol. He feeds Biscuits, closes the
              door to the LAPD crime lab, and at home he checks the door twice
              before he sleeps.
            </p>
            <p>
              <b>Grimsky</b>
              <br /> In a Sector 9 back room, Grimsky laughs too loud and spends
              too fast. He got his “get-out-of-jail-free” card… and now he’s
              terrified of the day he has to cash it.{" "}
            </p>
            <p>
              <b>McCoy (real)</b>
              <br /> He stares at the ceiling of a cheap clinic and whispers,
              “They wore my face.” He composes his resignation letter,
              determined to retire from the force. In a small note to Marion, he
              writes “Thanks to you and old man Skinner for saving my life. You
              owe me a dog.”
            </p>
            <p></p>
            <b>Noah & Ezekiel</b>
            <br /> The childish Noah, and the Skinner lookalike Ezekiel are
            missing from their cells. Nothing but piles of ash. Dust in the
            wind. A scorch mark where a replicant that wanted to live used to
            be.
          </p>
          <p>
            <b>Wanda (DiJi)</b>
            <br /> Her projection flickers in Marion’s apartment—one second
            warm, one second wrong. She says his name like she’s remembering it
            through static. In the quiet, Marion realizes: even love can be
            hacked.
          </p>
          <p>
            <b>Los Angeles</b>
            <br /> And always, the rain falls. The fog rolls. The lights
            flicker. And the city . . . the city speaks and doesn’t even slow
            down.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
          <img
            src={bladeRunners}
            style={{
              maxWidth: "100%",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
            alt="Blade Runners"
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-02.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">PROPHECY</h1>
              <small>Session 12 Notes</small>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner"
              >
                <span style={{ color: "white", textAlign: "center" }}>
                  At the top of Wallace Tower we find the questions to the
                  answers and the dramatic finale of the Fiery Angels case file
                  plays out.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for your ongoing campaign.
                </font>
                <br />
                <small>
                  ⇐ Previous: <a href="./blade-runner-session-11">Mother</a>
                  {/* ☠ Next: <a href="./blade-runner-session-13">Next Title</a> ⇒ */}
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSessionDoubleQuell;
